import { DistributionClass } from '@upright/common/model/distributions/types';
import { useDistributionData } from '@upright/ui/api/model/distributions';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { Summary as SharedSummary } from '@upright/ui/views/model-entity-views/shared/histogram/summary';
import styled from 'styled-components';

interface Props {
  name: string;
  score: number;
  scores: number[];
}

export function Summary(props: Props) {
  return (
    <SharedSummary
      name={props.name}
      score={props.score}
      scores={props.scores}
      benchmark={{
        name: 'benchmark fund universe',
        explanation: <BenchmarkUniverseExplanation />,
      }}
      netsum={{ explanation: <NetSumExplanation /> }}
    />
  );
}

export function FundBenchmarkUniverseCount() {
  const distributionQuery = useDistributionData(DistributionClass.FUNDS, 'nir');
  const count = distributionQuery.data?.length;
  if (count !== undefined) {
    return <>{count.toLocaleString('en-US', { maximumFractionDigits: 0 })}</>;
  }
  return null;
}

function BenchmarkUniverseExplanation() {
  return (
    <>
      Benchmark fund universe is based on <FundBenchmarkUniverseCount /> funds available in the Upright Platform.
    </>
  );
}

function NetSumExplanation() {
  return (
    <>
      The distribution is based on <b>net impact ratio</b>, representing funds’ relative net impact regardless of fund
      size. It is defined as (<Positive>positive impacts</Positive> - <Negative>negative impacts</Negative>) /{' '}
      <Positive>positive impacts</Positive>.
    </>
  );
}

const Positive = styled.span`
  color: ${BouColor.IMPACT_POSITIVE_GREEN};
  filter: brightness(85%);
  font-weight: bold;
`;
const Negative = styled.span`
  color: ${BouColor.IMPACT_NEGATIVE_PURPLE};
  font-weight: bold;
`;
